import { useEffect, useState } from 'react';
import { periodCloseApi } from '../services/financeApi';

const fmt = (d) => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Colombo' });

/**
 * The closed period, for entry screens: a transaction dated on or before closedThrough cannot be saved.
 * minDate goes on the date input; dateError(value) is the message to show and the reason to disable
 * the save button. The server refuses these dates anyway, so a failed read just leaves the form open.
 */
const useClosedPeriod = () => {
  const [closedThrough, setClosedThrough] = useState(null);

  useEffect(() => {
    let active = true;
    periodCloseApi.getLock()
      .then((res) => { if (active) setClosedThrough(res.data?.data?.closedThrough || null); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  // Colombo day after the last closed instant, as YYYY-MM-DD
  const minDate = closedThrough
    ? new Date(new Date(closedThrough).getTime() + 1).toLocaleDateString('en-CA', { timeZone: 'Asia/Colombo' })
    : undefined;

  const dateError = (value) => {
    if (!closedThrough || !value) return null;
    const day = String(value).slice(0, 10);
    return day < minDate ? `The books are closed up to ${fmt(closedThrough)}. Use a date after that, or ask Finance to reopen the month.` : null;
  };

  return { closedThrough, minDate, dateError };
};

export default useClosedPeriod;
